"use client";

import React from "react";
import { useSnapshot } from "valtio";
import { cn, getTypeAppOrPc } from "utils";
import { useParams } from "next/navigation";
import { HomeStore, rootStore } from "@/src/store";
import { useTaskCenterTasks } from "@hooks/useTaskCenterTasks";

export interface TaskCenterBadgeProps {
  /** 自定义类名 */
  className?: string;
}

/**
 * Task Center 徽章组件
 * 显示未claim任务数量或小红点
 */
export const TaskCenterBadge: React.FC<TaskCenterBadgeProps> = ({
  className,
}) => {
  const loginSnapshot = useSnapshot(rootStore.login);
  const { isOpen } = useSnapshot(HomeStore);
  const { locale } = useParams<{ locale: string }>();

  const { unclaimedCount } = useTaskCenterTasks({
    position: "list",
    channel: getTypeAppOrPc(),
    locale,
  });

  // 如果未登录，不显示
  if (!loginSnapshot.isLoggedIn || !unclaimedCount) {
    return null;
  }

  // 折叠状态：显示小红点
  return (
    <div
      className={cn(
        "w-1.75 h-1.75 bg-background_accent4_overlay20 rounded-full text-0",
        {
          "md:py-0.5 md:px-2 md:w-fit md:h-fit md:rounded md:bg-background_accent4_overlay20 md:text-content_accent4_primary md:body_bold_xs md:relative md:before:content-[''] md:before:absolute md:before:w-1.75 md:before:h-1.75 md:before:bg-content_accent4_primary md:before:-top-0.5 md:before:-right-0.5 md:before:rounded-full":
            isOpen,
        },
        className,
      )}
    >
      {isOpen ? `Unclaim (${unclaimedCount})` : ""}
    </div>
  );
};
